jQuery(function ($) {
  // Format area input - remove spaces from numbers
  function formatAreaValue(value) {
    if (!value) return '';
    // Remove all spaces from the value
    return value.toString().replace(/\s+/g, '');
  }

  // Handle area input changes - remove spaces
  $('#area-min, #area-max').on('input', function() {
    const $input = $(this);
    const cursorPosition = $input[0].selectionStart;
    const originalValue = $input.val();
    const formatted = formatAreaValue(originalValue);

    if (originalValue !== formatted) {
      $input.val(formatted);
      // Adjust cursor position
      const newPosition = cursorPosition - (originalValue.length - formatted.length);
      $input[0].setSelectionRange(newPosition, newPosition);
    }
  });

  // Accordion functionality
  $('.filter-accordion-toggle').on('click', function() {
    const $filter = $(this).closest('.filter-accordion');
    const isOpen = $filter.hasClass('filter-accordion-open');

    // Close all accordions
    $('.filter-accordion').removeClass('filter-accordion-open');

    // Open clicked accordion if it was closed
    if (!isOpen) {
      $filter.addClass('filter-accordion-open');
    }
  });

  // Function to save filter state to sessionStorage
  function saveFilterState() {
    const filterData = {
      cities: [],
      districts: [],
      classes: [],
      years: [],
      area_min: $('#area-min').val(),
      area_max: $('#area-max').val()
    };

    // Get checked checkboxes for each filter
    $('input[name="cities[]"]:checked').each(function() {
      filterData.cities.push($(this).val());
    });
    $('input[name="districts[]"]:checked').each(function() {
      filterData.districts.push($(this).val());
    });
    $('input[name="classes[]"]:checked').each(function() {
      filterData.classes.push($(this).val());
    });
    $('input[name="years[]"]:checked').each(function() {
      filterData.years.push($(this).val());
    });

    sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
  }

  // Function to get query string from saved filters
  function getFilterQueryString() {
    const saved = sessionStorage.getItem('objectFilters');
    if (!saved) return '';

    const filters = JSON.parse(saved);
    const params = [];

    if (filters.cities && filters.cities.length > 0) {
      filters.cities.forEach(city => params.push(`cities[]=${city}`));
    }
    if (filters.districts && filters.districts.length > 0) {
      filters.districts.forEach(district => params.push(`districts[]=${district}`));
    }
    if (filters.classes && filters.classes.length > 0) {
      filters.classes.forEach(cls => params.push(`classes[]=${cls}`));
    }
    if (filters.years && filters.years.length > 0) {
      filters.years.forEach(year => params.push(`years[]=${year}`));
    }
    if (filters.area_min) params.push(`area_min=${filters.area_min}`);
    if (filters.area_max) params.push(`area_max=${filters.area_max}`);

    return params.length > 0 ? '?' + params.join('&') : '';
  }

  // Update all object links with filter parameters
  function updateObjectLinks() {
    const queryString = getFilterQueryString();
    if (queryString) {
      $('.object-item .entry-link').each(function() {
        const $link = $(this);
        const href = $link.attr('href');
        if (href) {
          const url = new URL(href, window.location.origin);
          url.searchParams.set('ref', 'filtered');
          $link.attr('href', url.toString());
        }
      });
    }
  }

  if ($('.filters-form').length) {
    // Save filter state when form is submitted
    $('.filters-form').on('submit', function() {
      saveFilterState();
    });

    // Save filter state when checkboxes change
    $('.filter-checkbox').on('change', function() {
      saveFilterState();

      // Handle district visibility based on city selection
      updateDistrictVisibility();
    });

    // Save filter state when area inputs change
    $('.area-input').on('input', function() {
      saveFilterState();
    });

    // Function to update district visibility based on selected cities
    function updateDistrictVisibility() {
      const selectedCities = [];
      $('input[name="cities[]"]:checked').each(function() {
        selectedCities.push($(this).val());
      });

      if (selectedCities.length === 0) {
        // Show all districts if no city is selected
        $('.filter-checkboxes label[data-city]').show();
      } else {
        // Show only districts linked to selected cities
        $('.filter-checkboxes label[data-city]').each(function() {
          const $label = $(this);
          const cityId = $label.data('city');

          if (selectedCities.includes(cityId.toString())) {
            $label.show();
          } else {
            $label.hide();
            // Uncheck hidden districts
            $label.find('input[type="checkbox"]').prop('checked', false);
          }
        });
      }
    }

    // Initialize district visibility
    updateDistrictVisibility();

    // Clear filters button
    $('.clear-filters-button').on('click', function(e) {
      e.preventDefault();

      // Uncheck all checkboxes
      $('.filter-checkbox').prop('checked', false);

      // Clear area inputs
      $('#area-min, #area-max').val('');

      // Show all districts
      $('.filter-checkboxes label[data-city]').show();

      // Clear sessionStorage
      sessionStorage.removeItem('objectFilters');

      // Redirect to the page without query parameters
      window.location.href = window.location.pathname;
    });

    // Update object links on page load
    updateObjectLinks();
  }

  // On single object page, update the "Go back" link
  if ($('.post-return').length) {
    const queryString = getFilterQueryString();
    if (queryString) {
      const $backLink = $('.post-return');
      const href = $backLink.attr('href');
      if (href) {
        $backLink.attr('href', href + queryString);
      }
    }
  }
});
